import axios from "axios";
import { clearSession, goToLogin, getTokenJwt } from "@/utils/auth";

const api = axios.create({
  baseURL:
    process.env.VUE_APP_API_BASE_URL || "https://api-mondoc.loneless.xyz/api",
});

// interceptor request / response tetap sama...
api.interceptors.request.use((config) => {
  const token = getTokenJwt();
  if (token) {
    config.headers.token_jwt = token;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const isLoginRequest = err.config?.url?.includes("/login");
    if (
      !isLoginRequest &&
      (err.response?.status === 401 || err.response?.status === 403)
    ) {
      clearSession();
      goToLogin();
    }
    return Promise.reject(err);
  },
);

export default api;
